import React, { useState } from 'react';
import { CustomCalendar } from '../../Common/CustomCalendar';

interface CollectionRecord {
    slNo: number;
    amount: string;
    mode: string;
    status: string;
    onDate: string;
    location: string;
    date: string;
    createdDate: string;
    userStatus: string;
    isKey: string;
}

export const CollectionReport: React.FC = () => {
    const [dateVal, setDateVal] = useState('2026-03-28');
    const [warehouse, setWarehouse] = useState('Vashi');
    const [searchTerm, setSearchTerm] = useState('');

    // Mock collection database
    const [records] = useState<CollectionRecord[]>([
        {
            slNo: 1,
            amount: 'Kanchan Dairy Farm Malad',
            mode: '6000022',
            status: 'MUM0484',
            onDate: '-',
            location: 'Malad',
            date: '2017-11-30 11:14:12',
            createdDate: '2017-11-30 11:14:12',
            userStatus: 'Approved',
            isKey: 'No'
        },
        {
            slNo: 2,
            amount: 'Balaji Milk Point Worli',
            mode: '6000088',
            status: 'MUM0911',
            onDate: '-',
            location: 'Worli',
            date: '2018-05-12 14:22:05',
            createdDate: '2018-05-12 14:22:05',
            userStatus: 'Approved',
            isKey: 'No'
        },
        {
            slNo: 3,
            amount: 'Krishna Dairy Agency Vashi',
            mode: '6000101',
            status: 'MUM1204',
            onDate: '-',
            location: 'Vashi',
            date: '2019-09-24 16:45:10',
            createdDate: '2019-09-24 16:45:10',
            userStatus: 'Approved',
            isKey: 'Yes'
        }
    ]);

    const handleDeactivate = (slNo: number) => {
        if (window.confirm('Are you sure you want to deactivate this entry?')) {
            alert(`Record ${slNo} deactivated!`);
        }
    };

    const filteredRecords = records.filter(rec => 
        rec.amount.toLowerCase().includes(searchTerm.toLowerCase()) ||
        rec.mode.includes(searchTerm) ||
        rec.location.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="space-y-6">
            
            {/* CARD 1: Filters Panel */}
            <div className="bg-white rounded-3xl border border-[#ECECF2] px-4 py-3 shadow-sm space-y-4">
                
                {/* Header Row */}
                <div className="flex items-center justify-between border-b border-slate-100 pb-2">
                    <span className="text-sm font-bold text-[#1F1F1F] select-none">
                        Collection Report
                    </span>
                    {/* Down Arrow / Collapse Icon */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="text-[#1F1F1F] cursor-pointer">
                        <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                </div>

                {/* Filters Row - 2 columns */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    
                    {/* Choose Date */}
                    <CustomCalendar
                        label="Choose Date"
                        value={dateVal}
                        onChange={(val) => setDateVal(val)}
                    />

                    {/* Select Warehouse */}
                    <div className="space-y-1">
                        <label className="text-[11px] font-bold text-slate-800 block select-none">
                            Select Warehouse
                        </label>
                        <div className="relative">
                            <select
                                value={warehouse}
                                onChange={(e) => setWarehouse(e.target.value)}
                                className="w-full bg-white border border-slate-200 rounded-xl px-4 py-2.5 text-xs text-[#1F1F1F] font-semibold focus:ring-2 focus:ring-[#5D4037]/20 focus:border-[#5D4037] outline-none cursor-pointer appearance-none"
                            >
                                <option value="Vashi">Vashi</option>
                                <option value="Vasai">Vasai</option>
                                <option value="Manchar">Manchar</option>
                            </select>
                            {/* Dropdown Chevron Icon */}
                            <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="text-slate-600">
                                    <polyline points="6 9 12 15 18 9"></polyline>
                                </svg>
                            </div>
                        </div>
                    </div>

                </div>

                {/* Action Buttons row (Update only) */}
                <div className="flex items-center justify-center pt-2">
                    <button
                        className="px-6 py-2.5 bg-[#5D4037] hover:bg-[#4E342E] text-white font-bold text-xs rounded-xl cursor-pointer flex items-center gap-1.5 shadow-sm transition-all select-none"
                    >
                        {/* Sync SVG */}
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M6.18165 1.58557C6.53316 1.58557 6.81826 1.87079 6.81837 2.22229C6.81837 2.57388 6.53323 2.859 6.18165 2.859H3.80665C2.40449 2.8625 1.27054 4.00179 1.27345 5.40393L0.424814 5.40588H0.636728L1.27345 5.40393V10.1813L1.28614 10.441C1.41338 11.7216 2.49206 12.7229 3.80665 12.7262H8.55763C9.8721 12.7228 10.9509 11.7216 11.0781 10.441L11.0908 10.1813V6.9967C11.091 6.64521 11.3761 6.35998 11.7275 6.35998C12.0789 6.36013 12.3641 6.6453 12.3643 6.9967V10.1783L12.3594 10.3746C12.2617 12.3891 10.6001 13.9945 8.56056 13.9996L8.5586 13.0035V13.3629L8.56056 13.9996H3.80372L3.80567 13.3629V13.0035L3.80372 13.9996C1.69839 13.9945 -0.00449816 12.2837 8.92619e-06 10.1783V5.40588C-0.00393784 3.30097 1.69873 1.59068 3.80372 1.58557L3.80567 2.24182V2.22229L3.80372 1.58557H6.18165ZM9.35157 10.3395C9.70306 10.3395 9.98824 10.6246 9.98829 10.9762C9.98829 11.3277 9.70309 11.6128 9.35157 11.6129H3.01368C2.6621 11.6129 2.37696 11.3278 2.37696 10.9762C2.37701 10.6246 2.66213 10.3395 3.01368 10.3395H9.35157ZM9.53419 0.51916C9.93724 0.0123025 10.6353 -0.141615 11.209 0.138301L11.3242 0.201778L11.3887 0.2467L12.7178 1.30529L12.7578 1.33947C13.0145 1.5812 13.159 1.91912 13.1572 2.27209C13.1555 2.5997 13.0259 2.91157 12.7998 3.14611L11.794 4.34924V4.35021L8.35645 8.44885L8.34864 8.45959C8.20162 8.62764 8.00511 8.74564 7.78712 8.79748L7.78028 8.79943L5.99806 9.20373C5.96256 9.21174 5.92599 9.21653 5.88966 9.21838C5.3244 9.24648 4.83185 8.8353 4.7588 8.27404C4.75527 8.24687 4.75294 8.21941 4.75294 8.19201V6.35998C4.75295 6.34567 4.75392 6.33129 4.75489 6.31701C4.77065 6.08618 4.86318 5.86662 5.01856 5.69494L8.38673 1.88732L9.53321 0.517207L9.53419 0.51916ZM6.02638 6.47814V7.89123L7.4297 7.57287L10.0547 4.44104C9.76058 4.32053 9.50145 4.1495 9.28321 3.95959C9.08099 3.78365 8.90605 3.58664 8.75782 3.3883L6.02638 6.47814ZM10.6455 1.28186C10.6041 1.2647 10.5552 1.27564 10.5274 1.31213C10.5216 1.31963 10.5158 1.32735 10.5098 1.33459L9.62306 2.39221C9.747 2.59725 9.91409 2.8202 10.1191 2.99865C10.3802 3.22578 10.6623 3.35291 10.9785 3.3385L11.8272 2.32385C11.8439 2.30378 11.8627 2.28506 11.8818 2.26721L10.6455 1.28186Z" fill="white" />
                        </svg>
                        Update
                    </button>
                </div>

            </div>

            {/* CARD 2: Data Table Panel */}
            <div className="bg-white rounded-3xl border border-[#ECECF2] px-4 py-3 shadow-sm space-y-4">
                
                {/* Search / Show entries row */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <span className="text-sm font-bold text-[#1F1F1F] select-none">
                        Show 25 entries
                    </span>
                    
                    {/* Search Field */}
                    <div className="relative">
                        <input
                            type="text"
                            placeholder="Search"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="bg-white border border-slate-200 rounded-full px-4 py-1 text-xs outline-none focus:ring-2 focus:ring-[#5D4037]/20 focus:border-[#5D4037] w-48 font-medium placeholder-slate-400"
                        />
                    </div>
                </div>

                {/* Table container */}
                <div className="overflow-x-auto">
                    <table className="w-full text-left border-collapse min-w-[900px]">
                        <thead>
                            <tr className="bg-[#FFF9F3] text-[11px] font-bold text-slate-500 select-none">
                                <th className="py-3.5 px-4 rounded-l-xl">SL No</th>
                                <th className="py-3.5 px-4">Amount</th>
                                <th className="py-3.5 px-4">Mode</th>
                                <th className="py-3.5 px-4">Status</th>
                                <th className="py-3.5 px-4">On Date</th>
                                <th className="py-3.5 px-4">Date</th>
                                <th className="py-3.5 px-4">User</th>
                                <th className="py-3.5 px-4">Created</th>
                                <th className="py-3.5 px-4 text-center rounded-r-xl">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-100">
                            {filteredRecords.map((rec) => (
                                <tr key={rec.slNo} className="hover:bg-slate-50/50 transition-colors">
                                    <td className="py-3.5 px-4 text-xs font-semibold text-slate-800">
                                        {rec.slNo}
                                    </td>
                                    <td className="py-3.5 px-4 text-xs font-semibold text-slate-800">
                                        {rec.amount}
                                    </td>
                                    <td className="py-3.5 px-4 text-xs font-semibold text-slate-800">
                                        {rec.mode}
                                    </td>
                                    <td className="py-3.5 px-4 text-xs font-semibold text-slate-800">
                                        {rec.status}
                                    </td>
                                    <td className="py-3.5 px-4 text-xs font-semibold text-slate-800">
                                        {rec.onDate}
                                    </td>
                                    <td className="py-3.5 px-4 text-xs font-semibold text-slate-800">
                                        {rec.location}
                                    </td>
                                    <td className="py-3.5 px-4 text-xs font-semibold text-slate-800">
                                        {rec.date}
                                    </td>
                                    <td className="py-3.5 px-4 text-xs font-semibold text-slate-800">
                                        {rec.createdDate}
                                    </td>
                                    <td className="py-3.5 px-4 text-xs font-semibold text-slate-800">
                                        <div className="flex items-center justify-center gap-2">
                                            {/* Edit */}
                                            <button className="px-3 py-1 bg-[#5D4037] hover:bg-[#4E342E] text-white rounded-full text-[10px] font-semibold transition-all cursor-pointer">
                                                Edit
                                            </button>
                                            {/* Deactivate */}
                                            <button 
                                                onClick={() => handleDeactivate(rec.slNo)}
                                                className="px-3 py-1 go_erp-bg text-white rounded-full text-[10px] font-semibold transition-all cursor-pointer"
                                            >
                                                Deactivate
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            {filteredRecords.length === 0 && (
                                <tr>
                                    <td colSpan={9} className="py-8 text-center text-xs font-semibold text-slate-400">
                                        No collection records found matching your search.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

            </div>

        </div>
    );
};

export default CollectionReport;
